import {Component, OnInit} from '@angular/core';
import {Meta} from '@angular/platform-browser';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-qrdownload',
  templateUrl: './qrdownload.component.html',
  styleUrls: ['./qrdownload.component.scss']
})
export class QRDownloadComponent implements OnInit {

  constructor(
    private meta: Meta,
  ) {
    if (environment.noindex) {
      this.meta.updateTag({name: 'robots', content: 'noindex'});
    }
  }

  ngOnInit(): void {
  }

}
